import { copy } from 'ember-copy';
import FilterConstants from '../filter-constants';

export function isNearInfinity(value) {
  let result = value > FilterConstants.Limits.INFINITY - 1e52 && value < FilterConstants.Limits.INFINITY + 1e52;
  return result;
}

export function isNullOrUndefined(value) {
  return value === null || value === undefined;
}

export function isEmptyObject(value) {
  return Object.keys(value).length === 0;
}

/**
@function clone
@param  object
@returns clone of object
@description  This function takes parameter as an object and returns its clone
*/
export function clone(obj) {
  return copy(obj, true);
}

export function computeCompensateLoop(compensateForGbw) {
  var result = 1;
  if (compensateForGbw) {
    result = 3;
  }

  return result;
}

/**
@function toOrdinal
@param  number
@returns ordinal number
@description  This function takes parameter as a number and returns an ordinal number
*/
export function toOrdinal(order) {
  var orderText = '',
    orderNumber = parseInt(order);

  switch (orderNumber) {
    case 1:
      orderText = 'first_order';
      break;
    case 2:
      orderText = 'second_order';
      break;
    case 3:
      orderText = 'third_order';
      break;
    case 4:
      orderText = 'fourth_order';
      break;
    case 5:
      orderText = 'fifth_order';
      break;
    case 6:
      orderText = 'sixth_order';
      break;
    case 7:
      orderText = 'seventh_order';
      break;
    case 8:
      orderText = 'eighth_order';
      break;
    case 9:
      orderText = 'nineth_order';
      break;
    case 10:
      orderText = 'tenth_order';
      break;
  }

  return orderText;
}

export function displayStageType(type) {
  var typeName = type;
  switch (type) {
    case FilterConstants.filterType.lowPass:
      typeName = 'type_name_low_pass';
      break;
    case FilterConstants.filterType.highPass:
      typeName = 'type_name_high_pass';
      break;
    case FilterConstants.filterType.bandPass:
      typeName = 'type_name_band_pass';
      break;
    case FilterConstants.filterType.bandStop:
      typeName = 'type_name_band_stop';
      break;
  }

  return typeName;
}

/**
@function parallel
@param dynamtic args 
@description Calculates the parallel value.
@returns {numeric}
*/
export function parallel() {
  var summed = 0;

  for (var i = 0; i < arguments.length; i++) {
    summed = 1 / arguments[i] + summed;
  }

  var rtnValue = 1 / summed;

  return rtnValue;
}
